const getMetaValue = (document, field) =>
  (document.head.getElementsByTagName('meta') &&
   document.head.getElementsByTagName('meta')[field] &&
   document.head.getElementsByTagName('meta')[field].content)
  || 'MISSING_TAG';

export default getMetaValue;
